import { Box } from "@chakra-ui/react";
import React from "react";
import { ColumnSortState } from "shared/components/table/data/internal/DataTableColumnSort";
import { SmallArrowDownIcon } from "shared/icons/SmallArrowDownIcon";

export const DataTableColumnSortIndicator: React.FC<{
  state: ColumnSortState | undefined;
}> = ({ state }) => {
  if (state) {
    return (
      <Box right="8px">
        <SmallArrowDownIcon
          rotate={state === "desc" ? 180 : 0}
          transform="auto"
          transitionProperty="common"
          transitionDuration="normal"
          color="primary.300"
        />
      </Box>
    );
  }
  return null;
};
